import {CrudFormItemProps, CrudFormModal, nameof} from "digimuth-components/dist";
import {BeerCreateDto, BeerUpdateDto} from "../../../api";
import BeeftekaFileUploader from "../../components/fileUploader/beeftekaFileUploader";
import TextArea from "antd/es/input/TextArea";

export default function BeerModalForm(props: BeerModalProps) {
    const initValues = {
        "name": props.initialValues?.name,
        "description": props.initialValues?.description,
        "beerImageId": props.initialValues?.beerImageId,
        "beerImage": props.initialValues?.beerImage
    }
    const formItems: CrudFormItemProps[] = [
        {
            name: nameof<BeerCreateDto>("name"),
            label: "Nazwa",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
        },
        {
            name: nameof<BeerCreateDto>("description"),
            label: "Opis",
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
            children: <TextArea/>
        },
        {
            name: nameof<BeerCreateDto>("beerImageId"),
            label: "Zdjęcie",
            children: <BeeftekaFileUploader
                accept="image/jpeg,image/png"
                sizeLimitMb={6}
                defaultFile={initValues.beerImageId ? {
                    uid: initValues.beerImageId!.toString(),
                    name: initValues.beerImage?.fileName || "",
                    originFileObj: (initValues.beerImage as any).originFileObj
                } : undefined}
                useOrganisationFileApi={true}
                isFilePublic={true}
            />,
            rules: [
                {required: true, message: 'To pole jest wymagane'}
            ],
        },
    ];

    return <CrudFormModal
        formItems={formItems}
        forceRender={true}
        destroyOnClose={true}
        onSubmit={props.onSubmit}
        onModalCancelClicked={() => props.setModalVisibility(false)}
        initialValues={props.initialValues}
        modalOkText={props.saveButtonTitle}
        modalTitle={props.modalTitle}
        isModalVisible={props.isModalVisible}
        modalCancelText={props.cancelButtonTitle}
    />;
}

interface BeerModalProps {
    initialValues?: BeerCreateDto | BeerUpdateDto,
    isModalVisible: boolean;
    setModalVisibility: (isVisible: boolean) => any;
    onSubmit: (value: BeerCreateDto | BeerUpdateDto) => Promise<any>,
    modalTitle: string,
    saveButtonTitle: string,
    cancelButtonTitle: string,
}
